import { useTranslation } from 'react-i18next';
import { Button } from '@c2fo/liquidity';
import { TechnicalDifficultyIcon } from '@c2fo/liquidity/icons';
import invoices from '@/enterprise/assets/invoicesgrey.svg?url';
import { useBuyerNavigationLayoutContext } from '@/enterprise/components/BuyerNavigationLayout';
import NoDataState from '@/enterprise/components/NoDataState';
import EligibleInvoiceTable from '@/enterprise/features/eligibleInvoiceTable/EligibleInvoiceTable';
import QueryBoundaries from '@/shared/components/QueryBoundaries';
import { EditInvoicesProvider } from '../components/OfferBuilder/EditInvoices/EditInvoicesContext';

const EligibleInvoicesComponent = () => {
  const { t } = useTranslation();
  const { takerMarket } = useBuyerNavigationLayoutContext();

  return (
    <QueryBoundaries
      ErrorComponent={() => (
        <div className="px-8 py-12">
          <NoDataState
            icon={<TechnicalDifficultyIcon className="h-24 w-24" />}
            title={t('invoices.errorLoadingInvoices')}
            message={t('invoices.errorLoadingInvoicesDescription')}
            action={
              <Button size="sm" variant="ancillary" onClick={() => window.location.reload()}>
                {t('core.refresh')}
              </Button>
            }
          />
        </div>
      )}
      LoadingComponent={() => (
        <div className="px-8 py-12">
          <NoDataState
            icon={<img src={invoices} alt="invoices" className="h-28 w-28" />}
            message={t('invoices.fetchingEligibleInvoices')}
          />
        </div>
      )}
    >
      <EligibleInvoiceTable takerMarket={takerMarket} />
    </QueryBoundaries>
  );
};

const EligibleInvoices = () => (
  <EditInvoicesProvider>
    <EligibleInvoicesComponent />
  </EditInvoicesProvider>
);

export default EligibleInvoices;
